<script setup lang="ts">
import { AuthError, type EmailOtpType } from "@supabase/supabase-js";
import {
  onMounted,
  ref,
  useRoute,
  useRouter,
  useDialog,
  useAuth,
  useUser,
} from "#imports";
import MPCreatorOnboarding from "~/components/dialogs/MPAuth/MPCreatorOnboarding.vue";

const route = useRoute();
const router = useRouter();
const { openDialog } = useDialog();
const authStore = useAuth();
const userStore = useUser();
const error = ref<string | null>(null);

onMounted(async () => {
  const token_hash = route.query.token_hash as string;
  const type = route.query.type as EmailOtpType;
  const redirect = route.query.redirect as string;
  const code = route.query.code as string;
  const userType = route.query.userType as string;
  const isOnboarded = userStore.user.is_onboarded;

  if (code) {
    if (isOnboarded) {
      router.options.history.go(-1);
    } else {
      if (userType == "creator") {
        openDialog(MPCreatorOnboarding, {});
      }
    }
    return;
  }

  if (token_hash) {
    try {
      await authStore.verifyOtp({ token_hash, type });
      if (type === "email" && !redirect) {
        // This is a magic link login, redirect to home or dashboard
        router.push("/account");
      } else if (redirect) {
        router.push(redirect);
      } else {
        router.push("/reset-password");
      }
    } catch (e) {
      console.error("Error resetting password", e);
      if (e instanceof AuthError) {
        error.value = e.message;
      } else {
        error.value = "An unknown error occurred";
      }
    }
  }
});
</script>

<template>
  <main>
    <div v-if="error">
      {{ error }}
    </div>
    <div v-else>Verifying...</div>
  </main>
</template>
